export enum CustomerMutations {
  RESET = "RESET",
  SET_BIRTHDATE = "SET_BIRTHDATE",
  SET_CUSTOMER = "SET_CUSTOMER",
  SET_SIGNUP_STATE = "SET_SIGNUP_STATE",
}
